var tablePopUpCtr = document.querySelector('.suggested-use__full-size-table-ctr');
var tableCloseBtn = document.querySelector('.table__close-btn');
var tableViewBtns = document.querySelectorAll('.sqs-block-image-button');

if (tablePopUpCtr) {
  tableViewBtns.forEach(function(button) {
    button.addEventListener('click', function() {
      tablePopUpCtr.style.display = 'block';
    });
  });

  if (tableCloseBtn) {
    tableCloseBtn.addEventListener('click', function() {
      tablePopUpCtr.style.display = 'none';
    });
  }

  window.addEventListener('click', function(event) {
    if (event.target === tablePopUpCtr) {
      tablePopUpCtr.style.display = 'none';
    }
  });
}